module.exports = __webpack_public_path__ + "static/img/guide1.edae46c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/guide1.png
// module id = z0B7
// module chunks = 0